import { TestResultsModel } from "../models/TestResultModels";

export interface ParseResult<T> {
    success: boolean;
    data?: T;
    error?: string;
}

export class PlaywrightResultsParser {
    static parseTestResults(rawJson: unknown): ParseResult<TestResultsModel> {
        try {
            if (!rawJson || typeof rawJson !== "object") {
                return { success: false, error: "No test results data provided" };
            }
            const raw = rawJson as { suites?: unknown };
            if (!Array.isArray(raw.suites)) {
                return { success: false, error: "Invalid test results format: missing suites array" };
            }
            const model = TestResultsModel.fromRaw(rawJson as Parameters<typeof TestResultsModel.fromRaw>[0]);
            console.log("Parsed test results model:", model);
            return { success: true, data: model };
        } catch (error) {
            return {
                success: false,
                error: `Failed to parse test results: ${error instanceof Error ? error.message : "Unknown error"}`,
            };
        }
    }
}
